import React, { useState, useEffect, lazy, Suspense } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import "./benefits.css";
import htmlParser from "html-react-parser";



export default function Benefits({benefitsData}) {
 
  
  return (
    <>
   
    <div className="pt-mobile-2 mb-5 benefitscontainer">
    
      <Container >
        
        <Row>
          <Col sm={12} className="benefitsSectionheding">
            <div className="benefitsHeading">
              <h4>{htmlParser(benefitsData.influencerHeading2)}</h4>
            </div> 
          </Col>
         
          <Col sm={12} className="benefits-section mt-5">
          
             <ul>
                <li >
                {htmlParser(benefitsData.exclusivePoints1)}
                </li>
                <li>
                {htmlParser(benefitsData.exclusivePoints2)}
                </li>
                <li >
                {htmlParser(benefitsData.exclusivePoints3)}
                </li>
                <li className="alltextAnchorMorgan">
                {htmlParser(benefitsData.exclusivePoints4)}
                </li>
             </ul>
            
              </Col>
              <p className="subtextbenefits">{htmlParser(benefitsData.influencersubtext2)}</p>
              <p className="subtextbenefits1">{htmlParser(benefitsData.influencersubtext3)}</p>
        </Row>
        
        
      </Container>
    </div>
      
      </>
  );
}
